module.exports = __webpack_public_path__ + "pe.7f5e882d44fc81ab4045.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/pe.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/pe.svg
// module chunks = styles